import { isString } from 'lodash'

export class HubRedirectUrlData {
  constructor(public redirectUrl: string) {}
}

export const isRedirectUrl = (data: any): data is HubRedirectUrlData => isString(data?.redirectUrl)
